<template lang="pug">
header.app-header.navbar
  button.navbar-toggler.mobile-sidebar-toggler.d-lg-none(type='button', @click='mobileSidebarToggle')
    span.navbar-toggler-icon
  b-link.navbar-brand(to='#')
  button.navbar-toggler.sidebar-toggler.d-md-down-none(type='button', @click='sidebarToggle')
    span.navbar-toggler-icon
  b-navbar-nav.d-md-down-none
  b-navbar-nav.ml-auto
    b-nav-item.d-md-down-none
    b-nav-item.d-md-down-none
      i.icon-list
    b-nav-item.d-md-down-none
    HeaderDropdown
</template>
<script>
  import HeaderDropdown from './HeaderDropdown.vue'

  export default {
    name: 'header',
    components: {
      HeaderDropdown
    },
    methods: {
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue